<div class="count-text">
	<mat-icon svgIcon="checklist-borderless" />
	<span
		><span class="completed-count">{{ completedCount }}</span
		>/{{ totalCount }}</span
	>
</div>
<div class="track-bar">
	<div class="progress-bar" [ngStyle]="{ width: percentage + '%' }"></div>
</div>
